import type { MatchCard } from './matchRules';

export default function MatchFace({ card }: { card: MatchCard }) {
  const fill = card.fill ? 'currentColor' : 'none';
  const props = { fill, stroke: 'currentColor', strokeWidth: 2.4, strokeLinejoin: 'round' as const };
  return <svg viewBox="0 0 48 48" className="match-face" aria-hidden="true">
    {card.shape === 0 ? <circle cx="24" cy="24" r="12" {...props} />
      : card.shape === 1 ? <path d="M24 9L39 24L24 39L9 24Z" {...props} />
      : card.shape === 2 ? <path d="M24 10L39 37H9Z" {...props} />
      : card.shape === 3 ? <rect x="12" y="12" width="24" height="24" rx="2" {...props} />
      : card.shape === 4 ? <path d="M24 9L39 20L33 37H15L9 20Z" {...props} />
      : card.shape === 5 ? <path d="M16 10H32L40 24L32 38H16L8 24Z" {...props} />
      : card.shape === 6 ? <path d="M24 7L29 18L41 20L32 28L34 40L24 34L14 40L16 28L7 20L19 18Z" {...props} />
      : <path d="M19 9H29V19H39V29H29V39H19V29H9V19H19Z" {...props} />}
    {card.marked && <path d="M36 5H44V13" fill="none" stroke="currentColor" strokeWidth="3" />}
  </svg>;
}
